import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-group"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[5] || (_cache[5] = [
        _createElementVNode("span", { class: "text-white" }, "Create Playlist", -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = !_ctx.modal)),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            disabled: _ctx.name === '',
            class: "btn btn-primary"
          }, "Save", 8, _hoisted_6)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_Loading, {
            active: _ctx.loading,
            "is-full-page": false
          }, null, 8, ["active"]),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, [
                    _createTextVNode("Name"),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass([{'is-invalid':_ctx.invalid}, "form-control"]),
                    required: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.name]
                  ]),
                  (_ctx.invalid)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_3, "A Name is Required"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "Desription", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
                    required: "",
                    cols: "3",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.description]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}